import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import { isEmpty, isNotEmpty, samplingConstants, toThousands } from '../Service/Utils';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { HotTable } from '@handsontable/react';
import Handsontable from 'handsontable';
import copy from 'copy-to-clipboard';
import React from 'react';
import {
    Button,
    Row,
    Col,
    Select,
    Input,
    Table,
    Modal,
    Space,
    Tag,
    Popconfirm,
    Timeline,
    Popover,
    Tooltip,
    Image,
    Upload,
    message,
    Tabs
} from 'antd';
import {
    DeleteOutlined,
    HistoryOutlined,
    CopyOutlined,
    ApiOutlined,
    TagOutlined
} from '@ant-design/icons';

const { eventTypes } = samplingConstants

class SamplingManagementView extends React.Component {

    static tableDelta = 245;

    constructor() {
        super();

        // localStorage.setItem('sampling-defs.projectName', inputs.projectName);
        const projectName = localStorage.getItem('sampling-defs.projectName');
        this.state = {
            pageNo: 1,
            pageSize: 20,
            total: 0,
            projectName: isEmpty(projectName) ? '' : projectName,
            searchKey: undefined,
            defs: [],
            tags: [],
            tableHeight: document.body.clientHeight - SamplingManagementView.tableDelta,
            eventAssociatedPagesModalVisible: false,
            filters: {
                tagId: null,
                type: null,
            },
            sorters:[],

            copyCodeModal: false,
            copyCodeDefId: 0
        };
    }

    render() {
        return <>
            <Row>
                <Col flex="10px"></Col>
                <Col style={{ alignSelf: 'center' }}>
                    <span>项目组：</span>
                </Col>
                <Col>
                    <Select
                        value={this.state.projectName}
                        onChange={projectName => this.refreshDefintions({ projectName })}
                        style={{ width: 260 }}
                    >
                        {samplingConstants.projects.map(project => <Select.Option value={project.value}>
                            {project.title + " (" + project.value + ")"}
                        </Select.Option>)}
                        <Select.Option value="">全部</Select.Option>
                    </Select>
                </Col>
                <Col flex="10px"></Col>
                <Col>
                    <Input.Search
                        value={this.state.searchKey}
                        onChange={async ({ target: { value } }) => await this.refreshDefintions({ searchKey: value, pageNo: 1 })}
                        style={{ width: 300 }}
                        placeholder="输入事件标识/事件名称/创建人员搜索"
                    />
                </Col>
                <Col flex="auto"></Col>
                <Col style={{ padding: '0 10px 0 0', alignSelf: 'center' }}>
                    <Button
                        size="small"
                        onClick={() => {
                            if (!auth.allow('datap:real_time:trace_basic_info:manage')) {
                                message.warn("您没有批量导入的权限")
                                return
                            }
                            this.setState({ importingEventModal: true })
                        }}
                    >
                        批量导入埋点
                    </Button>
                </Col>
                {/* <Col style={{ padding: '0 10px 0 0' }}>
                    <Upload
                        name="file"
                        action={`/api/v1/sampling/definitions/import`}
                        accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                        maxCount={1}
                        showUploadList={false}
                        onChange={info => {
                            switch (info.file.status) {
                                case 'uploading':
                                    break;
                                case 'done':
                                    message.success('文件上传成功');
                                    break;
                                case 'error':
                                    console.log(info);
                                    message.error(`文件上传失败, ${info.file.response.message}`);
                                    break;
                                default:
                                    break;
                            }
                        }}
                    >
                        <Button
                            size="small"
                        >导入Excel文件</Button>
                    </Upload>
                </Col> */}
                <Col style={{ padding: '0 10px 0 0', alignSelf: 'center' }}>
                    <Button
                        size="small"
                        href='/real_time/sampling/pages'
                    >页面管理</Button>
                </Col>
                <Col style={{ padding: '0 10px 0 0', alignSelf: 'center' }}>
                    <Button
                        size="small"
                        type="primary"
                        href={`/real_time/sampling/new${isEmpty(this.state.projectName) ? '' : `?projectName=${this.state.projectName}`}`}
                    //onClick={this.incomingAddDef.bind(this)}
                    >注册埋点</Button>
                </Col>
            </Row>
            <div style={{ height: 5 }} />
            <Row>
                <Col flex="100%" style={{ padding: '10px' }}>
                    <Table
                        dataSource={this.state.defs}
                        bordered
                        size="small"
                        pagination={{
                            total: this.state.total,
                            current: this.state.pageNo,
                            pageSize: this.state.pageSize,
                        }}
                        rowKey="id"
                        style={{
                            width: '100%',
                        }}
                        scroll={{ y: this.state.tableHeight, x: 1200 }}
                        onChange={(pagination, filters, sorter, { action }) => {
                            this.refreshDefintions({
                                pageNo: pagination.current,
                                pageSize: pagination.pageSize,
                                filters,
                                sorter
                            });
                            //}
                        }}
                    >
                        <Table.Column
                            title="ID"
                            dataIndex="id"
                            key="id"
                            width={80}
                            fixed="left"
                            render={id => <Tag>{id}</Tag>}
                        />
                        <Table.Column
                            title="事件标识"
                            dataIndex="name"
                            key="name"
                            width={200}
                            ellipsis
                            fixed="left"
                            render={(name, { id }) => <span
                                style={{ padding: '0', cursor: 'pointer', color: '#1890ff' }}
                                onClick={() => window.location = `/real_time/sampling/edit/${id}`}
                            >
                                {name}
                            </span>}
                        />
                        <Table.Column
                            title="事件名称"
                            dataIndex="nameChs"
                            key="nameChs"
                            width={200}
                            fixed="left"
                            ellipsis
                        />
                        <Table.Column
                            title="事件类型"
                            dataIndex="type"
                            key="type"
                            width={120}
                            filters={samplingConstants.eventTypes.map(p => { return { text: p.title, value: p.value } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.type)) {
                                    return false;
                                }
                                return rd.type.indexOf(value) >= 0;
                            }}
                            filterSearch
                            render={(type) => <Tooltip title={type}>
                                <span>
                                    {eventTypes.find(t => t.value === type)?.title}
                                </span>
                            </Tooltip>}
                        />
                        <Table.Column
                            title="近3天上报数量"
                            dataIndex="near3dReportingCount"
                            key="near3dReportingCount"
                            width={130}
                            align='right'
                            sorter
                            render={count => {
                                if (isEmpty(count)) {
                                    return <span style={{ fontSize: 12, color: 'gray' }}>[无数据]</span>
                                } else {
                                    return <span style={{ color: '#ff4d4f' }}>{toThousands(count)}</span>
                                }
                            }}
                        />
                        <Table.Column
                            title="所属项目组"
                            dataIndex="projectName"
                            key="projectName"
                            width={120}
                            render={(projectName) => {
                                const project = samplingConstants.projects.find(p => p.value === projectName);
                                if (project) {
                                    return <Tooltip title={project.value}>
                                        <span>{project.title}</span>
                                    </Tooltip>;
                                }
                            }}
                        />
                        <Table.Column
                            title="事件分组"
                            dataIndex="eventGroup"
                            key="eventGroup"
                            width={120}
                            filters={this.eventGroupFilters()}
                            filterSearch
                        />
                        <Table.Column
                            title="所属页面"
                            dataIndex="pages"
                            key="pages"
                            ellipsis
                            width={170}
                            filters={this.pagesFilters()}
                            filterSearch
                            render={(pages, { id }) => {
                                switch (pages.length) {
                                    case 0:
                                        return <span style={{ fontSize: 12, color: 'gray' }}>[未关联页面]</span>;
                                    case 1:
                                        return <a
                                            style={{ fontSize: 12 }}
                                            href='/real_time/sampling/pages'
                                        >{pages[0].name}</a>;
                                    default:
                                        return <Popover
                                            title='关联的页面'
                                            content={pages.map(page => <Row>
                                                <Col>
                                                    <span>{page.name}</span>
                                                </Col>
                                            </Row>)}
                                        >
                                            <a
                                                style={{ fontSize: 12 }}
                                                href='/real_time/sampling/pages'
                                            >{pages[0].name} ...</a>
                                        </Popover>;
                                }
                            }}
                        />
                        <Table.Column
                            title="创建时间"
                            dataIndex="createdAt"
                            key="createdAt"
                            width={200}
                            sorter
                        //sorter={true}
                        />
                        <Table.Column
                            title="创建人员"
                            dataIndex="creatorName"
                            key="creatorName"
                            width={80}
                        />
                        <Table.Column
                            title="更新时间"
                            dataIndex="updatedAt"
                            key="updatedAt"
                            width={200}
                        //sorter={true}
                        />
                        <Table.Column
                            title="更新人员"
                            dataIndex="updaterName"
                            key="updaterName"
                            width={80}
                        />
                        <Table.Column
                            title="自定义标签"
                            dataIndex="tagId"
                            key="tagId"
                            width={240}
                            filterSearch
                            onFilter={() => true}
                            filters={this.state.tags.map(t => { return { text: t.name, value: t.id } })}
                            render={(tagId, rd) => <Select
                                value={tagId}
                                allowClear
                                showSearch
                                placeholder="请输入/选择，回车确定"
                                style={{ width: '100%' }}
                                optionFilterProp="children"
                                onChange={async value => {
                                    this.setState(({ defs }) => {
                                        rd.tagId = value;
                                        rd.incomingTag = undefined;
                                        return { defs };
                                    });
                                    await UIFetchService.method('PATCH',
                                        `/api/v1/sampling/definitions/${rd.id}/tags?tagId=${isEmpty(value) ? '' : value}`);
                                }}
                                onSearch={value => this.setState(({ defs }) => {
                                    rd.incomingTag = value;
                                    return { defs };
                                })}
                                onInputKeyDown={e => {
                                    if (e.code === 'Enter') {
                                        this.addTagIfNeeded(rd.incomingTag, rd);
                                    }
                                }}
                                onBlur={e => this.addTagIfNeeded(rd.incomingTag, rd)}
                                filterOption={(input, option) => {
                                    return option?.txt?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
                                }}
                            >
                                {this.state.tags.filter(tag => tag.projectName === rd.projectName).map(tag => <Select.Option key={tag.id} value={tag.id} txt={tag.name}>
                                    <Row>
                                        <Col>{tag.name}</Col>
                                        <Col flex='auto'></Col>
                                        {tagId !== tag.id && <Col>
                                            <Popconfirm
                                                title={`是否删除指定的标签:"${tag.name}"？`}
                                                onCancel={() => { }}
                                                okButtonProps={{ danger: true }}
                                                onConfirm={async () => {
                                                    await UIFetchService.delete(`/api/v1/sampling/tags/${tag.id}`, {});
                                                    await this.refreshTags();
                                                    await this.refreshDefintions({});
                                                }}
                                            >
                                                <Button
                                                    icon={<DeleteOutlined />}
                                                    danger
                                                    size='small'
                                                    type='link'
                                                />
                                            </Popconfirm>
                                        </Col>}
                                    </Row>
                                </Select.Option>)}
                            </Select>}
                        />
                        <Table.Column
                            title="操作"
                            key="operator"
                            width={300}
                            fixed="right"
                            render={(_, { id }) => <Row justify="center">
                                <Space>
                                <Button
                                        type="primary"
                                        size='small'
                                        shape="round"
                                        style={{backgroundColor: '#ffa12d', color: '#fff', fontSize: 12, borderColor: '#ffc53d'}}
                                        onClick={() => window.open(`/real_time/event_analysis?def_id=${id}`) }
                                > 查看数据 </Button>
                                <Button
                                        type="success"
                                        size='small'
                                        shape="round"
                                        style={{backgroundColor: 'rgb(82, 204, 111)', color: '#fefefe', fontSize: 12, borderColor: 'rgb(82, 204, 111)'}}
                                        onClick={() => this.prepareCopyCode(id) }
                                > 复制代码 </Button>
                                </Space>
                                <Tooltip title="查看修改历史">
                                    <Button
                                        icon={<HistoryOutlined />}
                                        type="link"
                                        size='small'
                                        onClick={() => this.incomingShowHistory(id)}
                                    />
                                </Tooltip>
                                <Popconfirm
                                    title="是否复制指定的埋点？"
                                    onConfirm={() => this.cloneDef(id)}
                                    onCancel={() => { }}
                                    okText="复制"
                                    okButtonProps={{ type: 'primary' }}
                                    cancelText="取消"
                                >
                                    <Tooltip title="复制事件">
                                        <Button icon={<CopyOutlined />} type="link" size='small' />
                                    </Tooltip>
                                </Popconfirm>
                                <Tooltip title="复制事件详情页链接">
                                    <Button
                                        icon={<TagOutlined />}
                                        type="link"
                                        size='small'
                                        onClick={() => {
                                            if (copy(`${window.location.origin}/real_time/sampling/edit/${id}`)) {
                                                message.success('复制成功');
                                            } else {
                                                message.success('复制失败');
                                            }
                                        }}
                                    />
                                </Tooltip>
                                <Tooltip title="关联事件所属页面">
                                    <Button
                                        icon={<ApiOutlined />}
                                        size='small'
                                        type="link"
                                        onClick={() => this.setState({
                                            eventAssociatedPagesModalVisible: true,
                                            incomingDefId: id
                                        })}
                                    />
                                </Tooltip>
                                <Popconfirm
                                    title="是否删除指定的埋点？"
                                    onConfirm={() => this.deleteDef(id)}
                                    onCancel={() => { }}
                                    okText="删除"
                                    okButtonProps={{ danger: true }}
                                    cancelText="取消"
                                >
                                    <Tooltip title="删除事件">
                                        <Button icon={<DeleteOutlined />} size='small' type="link" danger />
                                    </Tooltip>
                                </Popconfirm>
                                
                            </Row>}
                        />
                    </Table>
                </Col>
            </Row>
            {this.state.historyModalVisible && <SamplingHistoryModal
                visible={this.state.historyModalVisible}
                defId={this.state.incomingDefId}
                onCancel={() => this.setState({ historyModalVisible: false })}
                onOk={() => this.setState({ historyModalVisible: false })}
            />}
            {this.state.eventAssociatedPagesModalVisible && <EventAssociatedPagesModal
                visible={this.state.eventAssociatedPagesModalVisible}
                defId={this.state.incomingDefId}
                onCancel={() => this.setState({ eventAssociatedPagesModalVisible: false })}
                onDone={() => {
                    this.setState({ eventAssociatedPagesModalVisible: false });
                    this.refreshDefintions({});
                }}
            />}
            {this.state.addingEventModal && <EventAddingModal
                visible={this.state.addingEventModal}
                onCancel={() => this.setState({ addingEventModal: false })}
            />}
            {this.state.importingEventModal && <EventImportingModal
                visible={this.state.importingEventModal}
                onCancel={() => this.setState({ importingEventModal: false })}
            />}
            {this.state.copyCodeModal && <CopyCodeModal
                visible={this.state.copyCodeModal}
                defId={this.state.copyCodeDefId}
                onCancel={() => this.setState({ copyCodeModal: false, copyCodeDefId: 0 })}
            />}
        </>
    }

    async componentDidMount() {
        const user = await auth.authenticate();
        this.setState({ user })
        window.CyaLogger?.sendCustomEvent("page_view", null, "datap_liuliagfenxi_pv", { page_name: "埋点配置", user_name: user.account })

        window.onresize = () => {
            this.setState({ tableHeight: document.body.clientHeight - SamplingManagementView.tableDelta });
        };
        window.onresize();
        await this.refreshTags();
        await this.refreshDefintions({});
    }

    componentWillUnmount() {
        window.onresize = undefined;
    }

    eventGroupFilters() {
        if (this.state.projectsGroups === undefined) {
            return [];
        }
        // text value
        if (isEmpty(this.state.projectName)) {
            const opts = [];
            for (let key of Object.keys(this.state.projectsGroups)) {
                for (let group of this.state.projectsGroups[key]) {
                    opts.push({ text: `${key}/${group}`, value: group });
                }
            }
            return opts;
        }

        const groups = this.state.projectsGroups[this.state.projectName];
        if (groups === undefined || groups === null) {
            return [];
        }
        return groups.map(g => {
            return { text: g, value: g };
        });
    }

    pagesFilters() {
        if (this.state.projectsPages === undefined) {
            return []
        }
        // text value
        if (isEmpty(this.state.projectName)) {
            const opts = [];
            for (let key of Object.keys(this.state.projectsPages)) {
                for (let page of this.state.projectsPages[key]) {
                    opts.push({ text: `${key}/${page.name}`, value: page.id });
                }
            }
            return opts;
        }

        const pages = this.state.projectsPages[this.state.projectName];
        if (pages === undefined || pages === null) {
            return [];
        }
        return pages.map(g => {
            return { text: g.name, value: g.id };
        });
        
    }

    async addTagIfNeeded(tag, rd) {
        if (isEmpty(tag)) {
            return;
        }

        const found = this.state.tags.find(t => t.name === tag);
        if (found) {
            this.setState(({ defs }) => {
                rd.tagId = found.id;
                return { defs };
            });
            return;
        }
        const { tagId } = await UIFetchService.post(`/api/v1/sampling/tags`, { id: 0, name: encodeURI(tag), projectName: rd.projectName });
        if (isEmpty(tagId)) {
            return;
        }
        await UIFetchService.method('PATCH', `/api/v1/sampling/definitions/${rd.id}/tags?tagId=${tagId}`);
        await this.refreshTags();
        await this.refreshDefintions({});
    }

    async refreshTags() {
        const tags = await UIFetchService.get(`/api/v1/sampling/tags`);
        this.setState({ tags });
    }

    async refreshDefintions(inputs) {
        //console.info(inputs)
        if (inputs.pageNo === undefined) {
            inputs.pageNo = this.state.pageNo;
        }
        if (inputs.pageSize === undefined) {
            inputs.pageSize = this.state.pageSize;
        }
        if (inputs.searchKey === undefined) {
            inputs.searchKey = this.state.searchKey;
        }
        if (inputs.filters === undefined) {
            inputs.filters = this.state.filters;
        }
        if (inputs.projectName === undefined) {
            inputs.projectName = this.state.projectName;
        }
        if (isNotEmpty(inputs.projectName)) {
            inputs.filters.projectName = [inputs.projectName];
        } else {
            inputs.filters.projectName = null;
        }

        this.setState(inputs);
        localStorage.setItem('sampling-defs.projectName', inputs.projectName);
        const query = Object.keys(inputs).map(
            pk => `${pk}=${isEmpty(inputs[pk])
                ? ''
                : encodeURI(pk === 'filters' || pk === 'sorter'
                    ? JSON.stringify(inputs[pk])
                    : inputs[pk]
                )}`
        ).join('&')

        const rv = await UIFetchService.get(`/api/v1/sampling/definitions?${query}`);
        this.setState({ total: rv.total, defs: rv.items });
        const projectsGroups = await UIFetchService.get('/api/v1/sampling/projects/groups');
        const projectsPages = await UIFetchService.get('/api/v1/sampling/projects/pages');
        this.setState({ projectsGroups, projectsPages });
    }

    incomingAddDef() {
        this.setState({ addingEventModal: true });
    }

    incomingShowHistory(defId) {
        this.setState({
            historyModalVisible: true,
            incomingDefId: defId
        });
    }

    async deleteDef(defId) {
        await UIFetchService.method('DELETE', `/api/v1/sampling/definitions/${defId}`);
        message.success('埋点已经删除。');
        await this.refreshDefintions({});
    }

    async cloneDef(defId) {
        const rv = await UIFetchService.post(`/api/v1/sampling/definitions/${defId}/clone`, {});
        if (rv) {
            window.location = `/real_time/sampling/edit/${rv.defId}`;
        }
    }

    prepareCopyCode(defId) {
        this.setState({ copyCodeModal: true, copyCodeDefId: defId })
    }
}

class EventImportingModal extends React.Component {
    constructor() {
        super();
        this.state = {
            data: [
                ['项目组', '事件分组', '事件标识（英文名）', '事件名称（中文名）', '事件类型', '上报时机', '业务属性', '备注', '创建人员'],
                [null, null, null, null, null, null, null, null, null]
            ]
        }
    }

    render() {
        return <Modal
            title="导入数据"
            {...this.props}
            onOk={this.commitData.bind(this)}
            okText='导入'
            width={800}
            maskClosable={false}
        >
            <Row><span>说明：</span></Row>
            <Row><span>1、<span style={{ color: 'red' }}>红色</span>为必填字段，不可为空；其他字段非必填</span></Row>
            <Row><span>2、事件分组非必填，如百词斩的stat_group和夜曲的页面key可以填在该字段，其他项目组可根据情况填写</span></Row>
            <Row><span>3、事件类型只能填这些枚举值，不可自定义：imp（曝光事件）、click（点击事件）、page_view（页面浏览事件）、page_stay（页面停留事件）、
                        app_start（APP启动事件）、first_visit（首次访问事件）、add_cart（加购事件）、order（下单事件）、regist（注册事件）、logic（逻辑埋点）、custom_event（自定义事件）</span></Row>
            <Row><span>4、业务属性：如需批量导入业务属性，请按<a href='https://shimo.im/docs/VMAPVZgYw1UVBgqg' rel="noreferrer" target='_blank'>模版</a>梳理（或先咨询summer）</span></Row>
            <Row><span>5、所填信息必须与实际埋点信息一致，否则无法关联已上报的埋点数据</span></Row>
            <Row>
                <Col flex="100%">
                    <HotTable
                        height={400}
                        rowHeaders
                        colHeaders
                        data={this.state.data}
                        language="zh-CN"
                        manualColumnResize
                        manualRowResize
                        cells={row => {
                            if (row === 0) {
                                return { renderer: this.titleRenderer }
                            } else {
                                return {};
                            }
                        }}
                        fixedRowsTop={1}
                        licenseKey="non-commercial-and-evaluation"
                    >
                    </HotTable>
                </Col>
            </Row>
            <Row>
                <span style={{ color: 'gray' }}>将要导入的数据粘贴在上表空白处。</span>
            </Row>
        </Modal>
    }

    async commitData() {
        //console.log(this.state.data);
        const rv = await UIFetchService.post('/api/v1/sampling/definitions/inline_import', this.state.data);
        if (rv && rv.rows !== undefined) {
            message.success(`成功导入: ${rv.rows} 条记录`);
            this.props.onCancel();
        } else {
            message.error('导入失败。');
        }
    }

    titleRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        cellProperties.readOnly = true;
        Handsontable.renderers.TextRenderer.apply(Handsontable.renderers.TextRenderer,
            [instance, td, row, col, prop, value, cellProperties]);
        switch (col) {
            case 0:
            case 2:
            case 3:
            case 4:
                td.style.fontWeight = 'bold';
                td.style.color = 'red';
                td.style.background = '#F0F0F0';
                break;
            default:
                td.style.fontWeight = 'bold';
                td.style.color = 'black';
                td.style.background = '#F0F0F0';
                break;
        }
    }
}

class EventAddingModal extends React.Component {
    constructor() {
        super();
        this.state = {
            projectName: '',
            pages: [],
            associatedKeys: [],
        };
    }

    render() {
        return <Modal
            title="注册埋点"
            {...this.props}
            onOk={this.nextStep.bind(this)}
            okText='下一步'
            maskClosable={false}
        >
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col flex='150px' style={{ textAlign: 'right' }}>
                    <span style={{ color: 'red' }}>*</span> 所属项目组：
                </Col>
                <Col flex="auto">
                    <Select
                        value={this.state.projectName}
                        onChange={async projectName => await this.refreshPages(projectName)}
                        placeholder="请选择项目组"
                        size="small"
                        style={{ width: '100%' }}
                    >
                        {samplingConstants.projects.map(
                            project =>
                                <Select.Option value={project.value}>{project.title}({project.value})</Select.Option>)}
                    </Select>
                </Col>
            </Row>
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col flex='150px' style={{ textAlign: 'right' }}>
                    <Row>
                        <Col flex="100%" style={{ textAlign: 'right' }}>所属页面（可多选）：</Col>
                    </Row>
                    <Row justify='center'>
                        <Col>
                            <a
                                href='sampling/pages'
                                style={{ fontSize: 12 }}
                            >先去创建页面</a>
                        </Col>
                    </Row>
                </Col>
                <Col flex="auto">
                    <Select
                        value={this.state.associatedKeys}
                        onChange={associatedKeys => this.setState({ associatedKeys })}
                        placeholder="请选择所属页面"
                        size="small"
                        style={{ width: '100%' }}
                        mode="multiple"
                        allowClear
                    >
                        {this.state.pages.map(page => <Select.Option key={page.id} value={page.id}>
                            {page.name}
                        </Select.Option>)}
                    </Select>
                </Col>
            </Row>
        </Modal>;
    }

    async refreshPages(projectName) {
        this.setState({ projectName, associatedKeys: [] });
        const filters = encodeURI(JSON.stringify({ projectName: [projectName] }));
        const rv = await UIFetchService.get(`/api/v1/sampling/pages?filters=${filters}&pageNo=1&pageSize=10000`);
        if (rv) {
            this.setState({ pages: rv.items });
        }
    }

    nextStep() {
        if (isEmpty(this.state.projectName)) {
            message.error('所属项目组不能为空');
            return;
        }

        const queries = [`projectName=${encodeURI(this.state.projectName)}`];
        if (this.state.associatedKeys.length > 0) {
            queries.push(`associatedKeys=${encodeURI(this.state.associatedKeys.join(','))}`);
        }
        window.location = `/real_time/sampling/new?${queries.join('&')}`;
    }
}

class SamplingHistoryModal extends React.Component {
    constructor() {
        super();
        this.state = {
            jiffies: []
        };
    }

    render() {
        return <Modal
            title="修改历史"
            visible={this.props.visible}
            onOk={this.props.onCancel}
            onCancel={this.props.onCancel}
            maskClosable={false}
            width={800}
        >
            <Row>
                <Col flex="100%">
                    <Timeline
                        mode="left"
                    >
                        {this.state.jiffies.map(jiffy =>
                            <Timeline.Item
                                label={jiffy.updatedAt}
                            >
                                {jiffy.actions.map(action => <Row>
                                    <Col>{action}</Col>
                                </Row>)}
                                <Row>
                                    <Col>
                                        <Tag color="#1890ff">修改人</Tag>
                                        <span>{jiffy.updaterName}</span>
                                    </Col>
                                </Row>
                            </Timeline.Item>)}
                    </Timeline>
                </Col>
            </Row>
        </Modal>
    }

    async componentDidMount() {
        const jiffies = await UIFetchService.get(`/api/v1/sampling/definitions/${this.props.defId}/history`);
        this.setState({ jiffies });
    }
}

class EventAssociatedPagesModal extends React.Component {
    constructor() {
        super();
        this.state = {
            key: '',
            pages: [],
            associatedKeys: []
        };
    }

    render() {
        return <Modal
            title="关联页面"
            {...this.props}
            onOk={this.save.bind(this)}
            maskClosable={false}
            width={1000}
        >
            <Row style={{ margin: '0 0 10px 0' }}>
                <Col flex='300px'>
                    <Input.Search
                        size='small'
                        placeholder='按页面名/创建人员/更新人员搜索'
                        value={this.state.key}
                        onChange={({ target: { value } }) => this.refreshPages(value)}
                    />
                </Col>
            </Row>
            <Row>
                <Col flex="100%">
                    <Table
                        dataSource={this.state.pages}
                        bordered
                        size='small'
                        rowKey='id'
                        rowSelection={{
                            selectedRowKeys: this.state.associatedKeys,
                            onChange: associatedKeys => this.setState({ associatedKeys })
                        }}
                        scroll={{ x: 1200, y: 500 }}
                    >
                        <Table.Column
                            title='ID'
                            dataIndex='id'
                            key='id'
                            width={80}
                            render={id => <Tag>{id}</Tag>}
                        />
                        <Table.Column
                            title='页面图片'
                            dataIndex='pictureStorageKey'
                            key='pictureStorageKey'
                            width={90}
                            render={pictureStorageKey => isEmpty(pictureStorageKey)
                                ? <span style={{ fontSize: 12, color: 'gray' }}>[未上传图片]</span>
                                : <Image
                                    src={`/api/v1/sampling/pictures/preview?key=${encodeURI(pictureStorageKey)}`}
                                    height={50}
                                />}
                        />
                        <Table.Column
                            title='页面名称'
                            dataIndex='name'
                            key='name'
                            width={120}
                        />
                        <Table.Column
                            title='页面描述'
                            dataIndex='comment'
                            key='comment'
                            width={120}
                            ellipsis
                        />
                        <Table.Column
                            title='页面链接'
                            dataIndex='link'
                            key='link'
                            width={120}
                            ellipsis
                        />
                        <Table.Column
                            title='所属项目组'
                            dataIndex='projectName'
                            key='projectName'
                            width={120}
                            filters={samplingConstants.projects.map(p => { return { text: p.title, value: p.value } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.projectName)) {
                                    return false;
                                }
                                return rd.projectName.indexOf(value) >= 0;
                            }}
                            render={(projectName, rd) => {
                                const project = samplingConstants.projects.find(p => p.value === projectName);
                                if (project) {
                                    return <span>{project.title}</span>
                                }
                            }}
                        />
                        <Table.Column
                            title='覆盖应用端'
                            dataIndex='apps'
                            key='apps'
                            width={200}
                            filters={samplingConstants.apps.map(p => { return { text: p.title, value: p.value } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.apps)) {
                                    return false;
                                }
                                return rd.apps.find(app => app === value) !== undefined;
                            }}
                            render={(apps) => <Space>{apps.map(key => {
                                const app = samplingConstants.apps.find(a => a.value === key);
                                if (app) {
                                    return <Tag key={app.value}>{app.title}</Tag>
                                } else {
                                    return <></>
                                }
                            })}</Space>}
                        />
                        <Table.Column
                            title='创建人员'
                            dataIndex='creatorName'
                            key='creatorName'
                            width={80}
                        />
                        <Table.Column
                            title='创建时间'
                            dataIndex='createdAt'
                            key='createdAt'
                            width={180}
                            sorter={(a, b) => {
                                if (a.createdAt > b.createdAt) {
                                    return 1;
                                } else if (a.createdAt < b.createdAt) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }}
                        />
                        <Table.Column
                            title='更新人员'
                            dataIndex='updaterName'
                            key='updaterName'
                            width={80}
                        />
                        <Table.Column
                            title='更新时间'
                            dataIndex='updatedAt'
                            key='updatedAt'
                            width={180}
                            sorter={(a, b) => {
                                if (a.updatedAt > b.updatedAt) {
                                    return 1;
                                } else if (a.updatedAt < b.updatedAt) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }}
                        />
                    </Table>
                </Col>
            </Row>
        </Modal>;
    }

    async componentDidMount() {
        await this.refreshPages('');
    }

    async refreshPages(key) {
        this.setState({ key });
        const rv = await UIFetchService.get(`/api/v1/sampling/definitions/${this.props.defId}/associated_pages${isNotEmpty(key) ? `?key=${encodeURI(key)}` : ''}`);
        if (rv) {
            this.setState({ ...rv });
        }
    }

    async save() {
        await UIFetchService.put(`/api/v1/sampling/definitions/${this.props.defId}/associated_pages`, this.state.associatedKeys);
        message.success('事件到页面关联完成。');
        this.props.onDone();
    }
}

class CopyCodeModal extends React.Component {
    constructor() {
        super()
        this.state = {
            activeKey: 'js',
            definition: null
        }
    }

    async componentDidMount() {
        const def = await UIFetchService.get(`/api/v1/sampling/definitions/${this.props.defId}`);
        this.setState({ definition: def })
    }

    render() {
        return <Modal
            title="复制埋点代码"
            {...this.props}
            maskClosable={false}
            width={1000}
            footer={null}
        >
            <Tabs activeKey={this.state.activeKey}
                onChange={(k) => this.setState({ activeKey: k })}
            >
                <Tabs.TabPane tab='JS端' key="js">
                    {/* <CopyCodePanel type='js' /> */}
                </Tabs.TabPane>
                <Tabs.TabPane tab='微信小程序端' key='miniapp' >
                    {/* <CopyCodePanel type='miniapp' /> */}
                </Tabs.TabPane>
            </Tabs>
            {this.state.definition == null ? null :
                <CopyCodePanel definition={this.state.definition} type={this.state.activeKey} doneCopy={() => this.props.onCancel()} />
            }
           
        </Modal>
    }
}

class CopyCodePanel extends React.Component {
    constructor() {
        super()
        this.state = {
            sdkUrl: ''
        }
    }

    async componentDidMount() {
        let domNode = document.getElementById('sample-code');
        let instance = monaco.editor.create(domNode, {
            value: '',
            theme: 'vs-light',
            fontSize: 11,
            language: 'javascript',
            automaticLayout: true
        });
        this.codeEditor = instance;

        switch (this.props.type) {
            case "js":
                this.setState({ sdkUrl: "https://shimo.im/docs/vVqRVl1ooWHMwYqy" })
                break
            case "miniapp":
                this.setState({ sdkUrl: "https://shimo.im/docs/Wr3DVLVlGvU9WNkJ" })
                break
        }
        this.renderCode(this.props.type)
    }

    componentWillUnmount() {
        this.codeEditor?.dispose();
    }

    static getDerivedStateFromProps(props, current_state) {
        switch (props.type) {
            case "js":
                return { sdkUrl: "https://shimo.im/docs/vVqRVl1ooWHMwYqy" }
            case "miniapp":
                return { sdkUrl: "https://shimo.im/docs/Wr3DVLVlGvU9WNkJ" }
        }
    }

    renderCode(type) {
        const def = this.props.definition

        const eventType = isEmpty(def.eventType) ? "null" : "'" + def.eventType + "'"
        const eventGroup = isEmpty(def.eventGroup) ? "null" : "'" + def.eventGroup + "'"
        const eventName = "'" + def.eventName + "'"
        const eventValue = this.renderEventValue(def.eventValue)

        if (type === "js") {
            this.codeEditor.setValue(this.getJsCode(eventType, eventGroup, eventName, eventValue));
        } else if (type === "miniapp") {
            this.codeEditor.setValue(this.getMiniappCode(eventType, eventGroup, eventName, eventValue));
        }
        setTimeout(() => {
            this.codeEditor.getAction('editor.action.formatDocument').run();
        }, 200)
    }

    getJsCode(eventType, eventGroup, eventName, eventValue) {
        return `CyaLogger.sendCustomEvent(${eventType}, \n ${eventGroup}, \n${eventName}, \n ${eventValue});`
    }

    getMiniappCode(eventType, eventGroup, eventName, eventValue) {
        return `CyaLogger.sendCustomEvent(${eventType}, \n ${eventGroup}, \n${eventName}, \n ${eventValue});`
    }

    renderEventValue(eventValue) {
        if (eventValue == null) {
            return "null";
        }

        let eventValueStr = ""

        for (let i = 0; i < eventValue.length; i++) {
            const ev = eventValue[i]
            let valStr = ""
            switch(ev.type) {
                case 'string':
                case 'date':
                    valStr = `'xxx' `
                    break
                case 'number':
                case 'timestamp':
                case 'timestamp_ms':
                case 'enum':
                    valStr = `0  `
                    break
                case 'json':
                case 'Json':
                    valStr = ev.json == null ? "{}" : this.renderEventValue(ev.json)
            }
            eventValueStr += `'${ev.name}': ${valStr}`

            if (i < eventValue.length - 1) {
                eventValueStr += `,`
            }

            eventValueStr += `    //${ev.nameChs}`
            eventValueStr += "\n"
        }

        return "{ " + eventValueStr + " }"
    }

    doCopy() {
        copy(this.codeEditor.getValue())
        message.success("代码复制成功")
        this.props.doneCopy()
    }

    render() {
        return <>
            <Row style={{marginTop: 10}}>
                <Col>
                    <span style={{color: '#666'}}>说明：该代码按照数据中台提供的 <a href={this.state.sdkUrl} target='_blank'>SDK</a> 结构生成</span>
                </Col>
            </Row>
            <div style={{height: 20}} />
            <Row>
                <Col flex="100%">
                    <div id="sample-code" style={{ textAlign: 'left', height: 450, border: '1px' }}>
                    </div>
                </Col>
            </Row>
            <Row justify='center'>
                <Col>
                    <Button type="primary" onClick={() => this.doCopy()}>一键复制代码</Button>
                </Col>
            </Row>
        </>
    }
}


export default SamplingManagementView;
